"use client";
import { trunkAboutDesc } from "@/utils/trunck";
import { useTranslations } from "next-intl";
import Image from "next/image";
import Link from "next/link";
import Sale from "./Sale";

export default function AboutHome() {
  const t = useTranslations("Home");

  return (
    <div className="mt-10 pb-8">
      <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20">
        {/* Image Section */}
        <div className="relative w-full lg:w-1/2  h-105  xl:h-135 shrink-0">
          <Image
            src="/about-us.png"
            alt="About us image"
            quality={90}
            priority
            fill
            className="object-cover shadow-2xl"
          />

          {/* Decorative Overlay */}
          <div className="absolute inset-0 rounded-3xl ring-1 ring-black/10" />
        </div>

        {/* Text Content */}
        <div className="w-full px-5 lg:w-1/2 space-y-4">
          <h4 className="text-dark font-semibold text-sm sm:text-base tracking-wide uppercase">
            {t("about")}
          </h4>

          <h2 className="text-2xl sm:text-3xl md:text-4xl xl:text-5xl font-bold leading-tight text-main">
            {t("welcome")}
          </h2>

          <p className="text-[#606060] text-sm sm:text-base md:text-lg leading-relaxed max-w-xl">
            {trunkAboutDesc(t("aboutDes"), 320)}
          </p>

          <Link
            aria-label="Read More About Us"
            href="/about-us"
            className="inline-flex items-center justify-center bg-main text-white font-semibold py-3 px-7 rounded-xl border border-main transition-all duration-300 hover:bg-white hover:text-main hover:shadow-lg hover:-translate-y-0.5"
          >
            {t("readMore")}
          </Link>
        </div>
      </div>

      <Sale />
    </div>
  );
}
